import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

function safeParse(val, fallback) {
  if (val == null) return fallback
  try {
    const result = JSON.parse(val)
    return result != null ? result : fallback
  } catch (e) {
    return fallback
  }
}

export default new Vuex.Store({
  state: {
    // 登录状态
    logintoken: safeParse(sessionStorage.getItem('logintoken'), false),
    // 已登录账号信息
    accountInfo: safeParse(sessionStorage.getItem('accountInfo'), {}),
    // 已登录用户信息
    personInfo: safeParse(sessionStorage.getItem('personInfo'), {}),
    // 已登录机构信息
    organInfo: safeParse(sessionStorage.getItem('organInfo'), {}),
    // 赛事详情对象 actiondetails
    vuexactiondetails: safeParse(sessionStorage.getItem('vuexactiondetails'), {}),
    // 机构详情对象 organdetails
    vuexOrganDetails: safeParse(sessionStorage.getItem('vuexOrganDetails'), {}),
    // 学校详情对象 schoolDetails
    vuexSchoolDetails: safeParse(sessionStorage.getItem('vuexSchoolDetails'), {}),
    // 协会公告详情对象 Noticedetails
    vuexNoticedetails: safeParse(sessionStorage.getItem('vuexNoticedetails'), {}),
    // 新闻资讯详情对象 newsdetails
    vuexnewsdetails: safeParse(sessionStorage.getItem('vuexnewsdetails'), {}),
    // 机构：我的会员=> 会员详情
    // 基本信息
    memberbaseinfo: safeParse(sessionStorage.getItem('memberbaseinfo'), {}),
    // tab激活index
    tabIndexActive: safeParse(sessionStorage.getItem('tabIndexActive'), ""),
    // 赛事中心详情对象 racedetails
    vuexracedetails: safeParse(sessionStorage.getItem('vuexracedetails'), {}),
    vuexactivitydetails: safeParse(sessionStorage.getItem('vuexactivitydetails'), {}),

    vuexAboutData: safeParse(sessionStorage.getItem('vuexAboutData'), {}),
  },

  mutations: {
    // 存入token 
    savetoken(state, payload) {
      // 存入state 实现响应式
      state.logintoken = payload
      // 本地存储存入状态  实现数据持久化
      sessionStorage.setItem('logintoken', JSON.stringify(payload))
    },
    // 更新账号信息
    updateaccountInfo(state, payload) {
      state.accountInfo = payload
      sessionStorage.setItem('accountInfo', JSON.stringify(payload))
    },
    // 更新用户信息
    updatepersonInfo(state, payload) {
      state.personInfo = payload
      sessionStorage.setItem('personInfo', JSON.stringify(payload))
    },
    // 更新机构信息
    updateorganInfo(state, payload) {
      state.organInfo = payload
      sessionStorage.setItem('organInfo', JSON.stringify(payload))
    },

    // 更新赛事详情对象
    updateactiondetails(state, payload) {
      state.vuexactiondetails = payload
      sessionStorage.setItem('vuexactiondetails', JSON.stringify(payload))
      //无需写逻辑将其删除或置为空对象 因为每次打开详情页都会用到赛事列表页最新的赋值
    },
    // 更新会员机构详情对象
    updateorgandetails(state, payload) {
      state.vuexOrganDetails = payload
      sessionStorage.setItem('vuexOrganDetails', JSON.stringify(payload))
    },
    // 更新会员学校详情对象
    updateSchoolDetails(state, payload) {
      state.vuexSchoolDetails = payload
      sessionStorage.setItem('vuexSchoolDetails', JSON.stringify(payload))
    },
    // 更新协会公告详情对象
    updateNoticedetails(state, payload) {
      state.vuexNoticedetails = payload
      sessionStorage.setItem('vuexNoticedetails', JSON.stringify(payload))
    },
    // 更新新闻资讯详情对象
    updatenewsdetails(state, payload) {
      state.vuexnewsdetails = payload
      sessionStorage.setItem('vuexnewsdetails', JSON.stringify(payload))
    },
    // 更新我的会员详情对象
    // 基本信息
    updatememberbaseinfo(state, payload) {
      state.memberbaseinfo = payload
      sessionStorage.setItem('memberbaseinfo', JSON.stringify(payload))
    },
    updatetabIndexActive(state, payload) {
      state.tabIndexActive = payload
      sessionStorage.setItem('tabIndexActive', JSON.stringify(payload))
    },
    // 更新赛事中心详情对象
    updateracedetails(state, payload) {
      state.vuexracedetails = payload
      sessionStorage.setItem('vuexracedetails', JSON.stringify(payload))
    },
    // 更新活动中心详情对象
    updateActivitydetails(state, payload) {
      state.vuexactivitydetails = payload
      sessionStorage.setItem('vuexactivitydetails', JSON.stringify(payload))
    },
    updateAboutData(state, payload) {
      state.vuexAboutData = payload
      sessionStorage.setItem('vuexAboutData', JSON.stringify(payload))
    }
  },
  getters: {
    // 可以与state中字段重名  但是使用时不可以与自身组件data中数据重名
    logintoken: state => state.logintoken, // 登录状态
    accountInfo: state => state.accountInfo, // 已登录账号信息
    accountInfotype: state => state.accountInfo.type, // 已登录账号的类型 1 个人  2 机构
    accountRole: state => state.accountInfo.role, // 账号角色 1个人运动员 2学校管理员 3俱乐部教练
    accountPermissions: state => { // 账号权限码数组
      const p = state.accountInfo && state.accountInfo.permissions
      return p ? String(p).split(',').filter(Boolean) : []
    },
    // accountInfotype: state => 2,                  // 已登录账号的类型 1 个人  2 机构
    accountInfoaccount: state => state.accountInfo.account, // 已登录账号信息的账号
    accountInfopassword: state => state.accountInfo.password, // 已登录账号信息的密码

    personInfo: state => state.personInfo, // 已登录用户信息
    personInfoid: state => state.personInfo.id, // 已登录用户信息id (常用)
    // personInfoid: state => 3,               // 已登录用户信息id (常用)
    personInfostate: state => state.personInfo.state, // 已登录用户是否认证完成 1 为认证完成
    // personInfostate: state => 1,                         // 已登录用户是否认证完成  1 为认证完成 

    organInfo: state => state.organInfo, //已登录机构信息
    organInfoid: state => state.organInfo.id, // 已登录机构信息id (常用)
    // organInfoid: state => 1,                         // 已登录机构信息id (常用)
    organInfostate: state => state.organInfo.state, // 已登录机构是否认证完成 1 为认证完成 
    // organInfostate: state => 1,                    // 已登录机构是否认证完成 1 为认证完成 

    vuexactiondetails: state => state.vuexactiondetails, //赛事详情信息
    vuexOrganDetails: state => state.vuexOrganDetails, //机构详情信息
    vuexOrganDetailsid: state => state.vuexOrganDetails.id, //机构详情id
    vuexSchoolDetails: state => state.vuexOrganDetails, //学校详情信息
    vuexSchoolDetailsId: state => state.vuexOrganDetails.id, //学校详情信息id
    vuexNoticedetails: state => state.vuexNoticedetails, //协会公告详情信息
    vuexnewsdetails: state => state.vuexnewsdetails, //新闻资讯详情信息

    memberbaseinfo: state => state.memberbaseinfo, //基本信息(机构：会员详情)
    memberbaseinfoid: state => state.memberbaseinfo.personId, //基本信息id(机构：会员详情)

    tabIndexActive: state => state.tabIndexActive, //tab index
    vuexracedetails: state => state.vuexracedetails, //赛事中心详情信息
    vuexactivitydetails: state => state.vuexactivitydetails, //赛事中心详情信息
    vuexAboutData: state => state.vuexAboutData, //关于我们信息
  },
  actions: {},
  modules: {}
})
